import React from 'react';
import './MeetMike.css';

function MeetMike() {
  return (
    <section className="page-section meetmike-page">
      <div className="meetmike-top-rule" />
      <div className="section-header">
        <p className="section-eyebrow">The Artist</p>
        <h2 className="section-title">Meet Mike</h2>
        <div className="gold-rule" />
      </div>

      <div className="mike-layout">
        <div className="mike-video-wrap">
          <iframe
            src="https://www.youtube.com/embed/jyi8c25AZ2Q?rel=0&modestbranding=1"
            title="Georgia on My Mind"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        </div>

        <div className="mike-bio">
          <p className="bio-quote">
            "I just want to bring smiles to people's faces with my music."
          </p>
          <p className="bio-para">
            Mike's passion for music started at an early age — his earliest memories hanging out
            in smoky country bars and county fairs, watching his dad tear it up on the drums.
          </p>
          <p className="bio-para">
            A native of the Rockville/Gaithersburg area of Maryland, Mike started his musical
            journey as a rock and go-go drummer for high-school bands. When he discovered he
            could sing, he picked up a guitar and found his soul was in songwriting and performing
            inspirational, uplifting music.
          </p>
          <p className="bio-para">
            The old-school influence is unmistakable to anyone who's seen him perform. He carries
            it forward with warmth, soul, and genuine gratitude.
          </p>
          <div className="bio-influences">
            {['Elvis', 'Skynyrd', 'Hendrix', 'John Bonham', 'Marshall Tucker'].map(inf => (
              <span key={inf} className="influence-tag">{inf}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default MeetMike;
